import { render } from "./co-footer.vue?vue&type=template&id=1d7fa10a&scoped=true"
import script from "./js/co-footer.js?vue&type=script&lang=js&external"
export * from "./js/co-footer.js?vue&type=script&lang=js&external"

import "./co-footer.vue?vue&type=style&index=0&id=1d7fa10a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7fa10a"]])

export default __exports__